import React from 'react';

interface DirectionToggleProps {
  leftLabel: string;
  rightLabel: string;
  selectedDirection: string;
  onDirectionChange: (direction: string) => void;
}

const DirectionToggle: React.FC<DirectionToggleProps> = ({
  leftLabel,
  rightLabel,
  selectedDirection,
  onDirectionChange
}) => {
  return (
    <div className="direction-toggle">
      <button 
        className={`direction-btn ${selectedDirection === leftLabel.toLowerCase() ? 'active' : ''} rise`}
        onClick={() => onDirectionChange(leftLabel.toLowerCase())}
      >
        {leftLabel}
      </button>
      <button 
        className={`direction-btn ${selectedDirection === rightLabel.toLowerCase() ? 'active' : ''} fall`}
        onClick={() => onDirectionChange(rightLabel.toLowerCase())}
      >
        {rightLabel}
      </button>
    </div>
  );
};

export default DirectionToggle;
export { DirectionToggle };
